import React from 'react';
import { Star, ExternalLink, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  platform: 'Zillow',
  rating: 5.0,
  count: 253,
  link: 'https://www.zillow.com/profile/RothGetsResults'
}, {
  platform: 'FastExpert',
  rating: 5.0,
  count: 143,
  link: 'https://www.fastexpert.com/agents/krystle-roth-2375/'
}, {
  platform: 'Yelp',
  rating: 5.0,
  count: 90,
  link: 'https://www.yelp.com/biz/roth-real-estate-group-redlands-2'
}, {
  platform: 'Facebook',
  rating: 4.9,
  count: 78,
  link: 'https://www.facebook.com/p/Krystle-Roth-Realtor-100063780903470/'
}];
const themes = [{
  text: 'Walks first-time buyers through every step with patience',
  count: '40+'
}, {
  text: 'Deep Inland Empire market knowledge — Redlands native',
  count: '32+'
}, {
  text: 'Negotiates above asking, often in multiple-offer situations',
  count: '28+'
}, {
  text: 'Responsive day or night — texts, calls, emails answered fast',
  count: '25+'
}, {
  text: 'Team praised by name — Roth Real Estate Group as a unit',
  count: '18+'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function SellerReviews() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-253">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} variants={containerVariants} data-id="element-254">

        <motion.div variants={itemVariants} className="mb-3" data-id="element-255">
          <h2 className="text-2xl font-serif text-brand-dark" data-id="element-256">
            What sellers are saying
          </h2>
        </motion.div>

        <motion.div variants={itemVariants} className="flex flex-wrap items-center gap-3 mb-2" data-id="element-257">

          {reviews.map(r => <a key={r.platform} href={r.link} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-brand-light hover:border-brand-forest hover:shadow-sm text-sm transition-all group" data-id="element-258">

              <Star size={14} className="fill-amber-400 text-amber-400" data-id="element-259" />
              <span className="font-mono text-sm font-medium text-brand-dark" data-id="element-260">
                {r.rating}
              </span>
              <span className="text-brand-dark" data-id="element-261">{r.platform}</span>
              <span className="text-brand-muted text-xs font-mono" data-id="element-262">
                ({r.count})
              </span>
              <ExternalLink size={12} className="text-brand-muted opacity-0 group-hover:opacity-100 transition-opacity ml-1" data-id="element-263" />

            </a>)}
        </motion.div>

        <motion.div variants={itemVariants} className="mb-8" data-id="element-264">
          <p className="text-sm text-brand-muted" data-id="element-265">
            AI-generated themes from verified client reviews
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-266">
          {themes.map((theme, idx) => <motion.div key={idx} variants={itemVariants} className="flex items-start gap-3" data-id="element-267">

              <Check className="text-brand-forest shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-268" />

              <p className="text-sm" data-id="element-269">
                <span className="font-semibold text-brand-dark" data-id="element-270">
                  {theme.text}
                </span>{' '}
                <span className="text-brand-muted text-xs" data-id="element-271">
                  (mentioned {theme.count} times)
                </span>
              </p>
            </motion.div>)}
        </div>

        <motion.div variants={itemVariants} className="pt-8 border-t border-brand-light" data-id="element-272">

          <p className="font-serif italic text-brand-muted text-sm leading-relaxed" data-id="element-273">
            "Across 560+ reviews on Zillow, FastExpert, Yelp, and Facebook,
            clients consistently praise Krystle and the Roth Real Estate Group
            for their hometown knowledge of Redlands and the Inland Empire,
            tireless responsiveness, and a calm, no-pressure approach that
            still delivers above-asking results."
          </p>
        </motion.div>
      </motion.div>
    </section>;
}